module.exports = new __parcel__URL__("battle_royale_button_text.a4728905.png").toString();